import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DashboardConfigDto } from 'src/app/config/shared/dto/dashboard-config.dto';

@Component({
  selector: 'wl-dashboard-neo-config',
  templateUrl: './dashboard-neo-config.component.html',
  styleUrls: ['./dashboard-neo-config.component.less'],
    standalone: false
})
export class DashboardNeoConfigComponent {
  private _config: DashboardConfigDto = {} as DashboardConfigDto;
  @Input() public get config(): DashboardConfigDto {
    return this._config;
  }
  public set config(value: DashboardConfigDto) {
    this._config = value;
  }

  @Output() datesChanged = new EventEmitter<boolean>();

  public constructor() {}

  public overrideDatesChanged() {
    if (!this._config.OverrideDateRange) {
      this.config.StartDate = new Date(new Date().getFullYear(), 0, 1);
      this.config.EndDate = new Date();
    }
  }
}
